import React, { lazy, useEffect, useState } from 'react';
import { useGeoLocation } from '../../../hooks/Front/home/useHome';
import { Carousel, Col, Row } from 'react-bootstrap';
import clienteAxios from '../../../configAxios/configAxios';
import { Helmet } from 'react-helmet';
import { Button } from 'antd';
import './slider.css'
const { errorSwal } = lazy(() => import('../../../helper/swalHelpers'));
const reloadPage = () => {
    window.location.reload();
}

const Slider = ({ seccion }) => {

    const [sliders, setSliders] = useState([])
    const { geoLocation } = useGeoLocation();

    const fetchSliders = async () => {
        try {
            const response = await clienteAxios.get(`sliders/modulo/${seccion}`);

            if (response.status === 200) {
                let sliders = response.data.data
                let seccion = sliders.filter((slider) => slider.Seccion === "PRINCIPAL")

                setSliders(seccion);
                return
            }
            setSliders([]);
        } catch (error) {

            errorSwal("Algo ha fallado!", "Por favor vuelve a intentarlo", "Recargar página", reloadPage)
        }
    }

    useEffect(() => {
        fetchSliders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!sliders || sliders.length < 1) return null;

    return (
        <>
            {/* WARNING CONSOLE */}
            {/* <Helmet>            
            {sliders && sliders.length > 0 &&
                sliders.map((slider, index) =>
                    <link key={index} rel="preload" as="image" href={slider.Imagen} />
            )}
        </Helmet> */}
            <Row>
                <Col className="p-0">
                    <Carousel className="slider-a">
                        {sliders && sliders.length > 0 &&
                            sliders.map((slider, index) =>
                                slider.Link && slider.Ocular === 0 ?
                                    <Carousel.Item key={index}>
                                        <div>
                                            <a href={slider.Link}>
                                                <h1 className=" bold-title-hyundai d-none d-md-block position-title text-shadow-title mb-0 w-100">{slider.Titulo}
                                                    <span> <h5 className="d-none d-md-block parrafo-hyundai my-2 text-white">{slider.Descripcion}</h5></span>
                                                </h1>
                                                <h6 className=" bold-title-hyundai font-title-mobile position-title text-shadow-title d-md-none mx-2 mb-3 w-100">{slider.Titulo}
                                                    <span className="parrafo-hyundai f-subtitle-mobile text-white d-block d-md-none ">{slider.Descripcion}</span></h6>
                                                <img className="lazyload img-fluid w-100 slider-lg" alt={""} data-src={slider.Imagen} data-sizes="auto" />
                                            </a>
                                        </div>
                                    </Carousel.Item>
                                // : slider.Ocular === 1 
                                //     // && geoLocation && geoLocation.region && 
                                //     // geoLocation.countryCode === "CL" && geoLocation.region === "RM" 
                                //     ?
                                //     <Carousel.Item key={index}>
                                //         <div>
                                //             <Button type="text" className="w-100 h-100 ocular-parent-toggler p-0" >
                                //                 <h1 className=" bold-title-hyundai d-none d-md-block position-title text-shadow-title mb-0 w-100">
                                //                     {slider.Titulo}
                                //                     <span>
                                //                         <h5 className="d-none d-md-block parrafo-hyundai my-2 text-white">
                                //                             {slider.Descripcion}
                                //                         </h5>
                                //                     </span>
                                //                 </h1>
                                //                 <h6 className=" bold-title-hyundai font-title-mobile position-title text-shadow-title d-md-none mx-2 mb-3 w-100">
                                //                     {slider.Titulo}
                                //                     <span className="parrafo-hyundai f-subtitle-mobile text-white d-block d-md-none ">
                                //                         {slider.Descripcion}
                                //                     </span>
                                //                 </h6>
                                //                 <img className="lazyload img-fluid w-100 slider-lg" alt={""} data-src={slider.Imagen} data-sizes="auto" />
                                //             </Button>
                                //         </div>
                                //     </Carousel.Item>
                                    : slider.Ocular === 0 &&                                    
                                    <Carousel.Item key={index}>
                                        <div>
                                            <h1 className=" bold-title-hyundai d-none d-md-block position-title text-shadow-title mb-0 w-100">{slider.Titulo}
                                                <span> <h5 className="d-none d-md-block parrafo-hyundai text-shadow-title my-2 text-white">{slider.Descripcion}</h5></span>
                                            </h1>
                                            <h6 className=" bold-title-hyundai font-title-mobile position-title text-shadow-title d-md-none mx-2 mb-3 w-100">{slider.Titulo}
                                                <span className="parrafo-hyundai f-subtitle-mobile text-shadow-title text-white d-block d-md-none ">{slider.Descripcion}</span></h6>
                                            <img className="lazyload img-fluid w-100 slider-lg" alt={""} data-src={slider.Imagen} data-sizes="auto" />                                    
                                        </div>
                                    </Carousel.Item>
                                
                            )
                        }
                    </Carousel>
                </Col>
            </Row>
        </>
    );
}

export default Slider;
